import React, {
  useRef,
  useState,
  forwardRef,
  useImperativeHandle
} from "react";
import SignaturePad from "react-signature-pad-wrapper";
import { StyledContainer } from "./styles";

interface Props {
  height?: number;
}
const JPEG_MIME = "image/jpeg";

const SignatureInput = forwardRef(({ height }: Props, ref) => {
  const sigPadRef: any = useRef();

  useImperativeHandle(ref, () => ({
    clear: () => {
      sigPadRef?.current.clear();
    },
    sign: () => {
      if (sigPadRef?.current.isEmpty()) {
        return null;
      }
      const newSignatureData = sigPadRef?.current.toDataURL(JPEG_MIME, 0.8);
      return newSignatureData;
    }
  }));

  return (
    <StyledContainer>
      <SignaturePad 
        ref={sigPadRef} 
        options={{ 
          penColor: "black",
          backgroundColor: "white" // Add this
        }} 
        height={height || null} 
      />
    </StyledContainer>
  );
});

export default SignatureInput;